import { store } from "..";
import { globalActions } from "../features/global/globalSlice";

const SettingsLoader = async () => {
    const { settings } = store.getState().global;
    const settingsPromise = settings.length
        ? Promise.resolve()
        : store.dispatch(globalActions.getSettings());

    await Promise.all([settingsPromise]);
    return null;
};

export default SettingsLoader;
